module.exports = __webpack_public_path__ + "static/Homepage-Hero2-f268ebfe16c6f03dacf2dd2daf1d4b5e.png";